import Api from '@/services/api.js';

export default {
  getAuditsByModelSubjectId(id, model) {
    return Api.get(`audits/${model}/${id}`)
  }
}